import { ComponentProps } from "react";
import { useFormContext } from "react-hook-form";
import { Label } from "../ui/label";

interface BasicInputProps extends ComponentProps<"input"> {
  label?: string;
  error?: string;
  prefix: string;
  name: string;
}

export const PrefixInput = ({
  error,
  label,
  name,
  prefix,
  style,
  ...props
}: BasicInputProps) => {
  const { register } = useFormContext();

  return (
    <Label htmlFor={name} className="w-full text-sm font-medium">
      {label}
      <div
        style={style}
        className="mt-2 flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
      >
        {prefix}
        <input
          className="bg-transparent pl-2 outline-none"
          {...register(`${name}`)}
          id={props.id || name}
          {...props}
        />
      </div>
      <p className="mt-1 font-light text-error">{error}</p>
    </Label>
  );
};
